import FeedbackList from './FeedbackList';

export * from './queries';

export default {
    list: FeedbackList,
};
